// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","linkGiphy":"Footer_linkGiphy__dxJwL","redes":"Footer_redes__98fJ+"};